import React from 'react';
import LoggedLayout from '../components/layouts/LoggedLayout';
import { GetShopEleveQuery } from '../graphql/generated/graphql';
import { setUser } from '../store/actions/user.actions';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { QUERY_SHOP_ELEVE } from '../graphql/query/shop/getEleve.query';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import { Route, Switch } from 'react-router';
import routes from '../routes/routes';
import usePublicShop from '../hooks/usePublicShop';
import { ServiceMessages } from '../components/molecules/serviceMessages';
import { getUserStateFromQuery } from '../helpers/transformApiResponse/user';

const PublicShopViews = () => {
  const { shopId, classeId } = usePublicShop();
  const dispatch = useDispatch();
  const { loading, error } = useQuery<GetShopEleveQuery>(QUERY_SHOP_ELEVE, {
    variables: { id: shopId, classeId },
    onCompleted: data => dispatch(setUser(getUserStateFromQuery(data.eleve)))
  });
  if (loading) return <LoadingLayout variant="centeredOnly" />;
  if (error)
    return (
      <ServiceMessages
        text={error.message}
        status={404}
        extra={"Veuillez contacter l'élève responsable de la e-boutique !"}
      />
    );
  return (
    <LoggedLayout shopId={shopId}>
      <Switch>
        {routes.map((route, i) => (
          <Route key={i} exact path={route.path} component={route.component} />
        ))}
      </Switch>
    </LoggedLayout>
  );
};

export default PublicShopViews;
